// components/BuildTypeToggle.js
//
// "What are you building?" — a full carbon/biogenic/weight build-up, or a cost-only material that is
// priced in Nezo from the account's Rate Library. Same selectable cards as VisibilityToggle.
// `compact`: two small pill buttons on one line, with the chosen option's explanation underneath —
// for tight layouts (Build New Material's side column).

import React from 'react';
import './VisibilityToggle.css';

const OPTIONS = [
  {
    key: 'full',
    costOnly: false,
    icon: '🧱',
    title: 'Full build-up',
    desc: 'Add carbon, biogenic and weight line items below.',
  },
  {
    key: 'cost-only',
    costOnly: true,
    icon: '💲',
    title: 'Cost only',
    desc: 'Priced in Nezo from your Rate Library — no line items needed. You can add a build-up later. Unit and category are required.',
  },
];

function BuildTypeToggle({ costOnly, onChange, compact = false }) {
  if (compact) {
    const active = OPTIONS.find(o => o.costOnly === !!costOnly);
    return (
      <div className="vt-compact">
        <div className="vt-compact__row">
          <span className="vt-compact__label">What are you building?</span>
          <div className="vt-compact__pills" role="radiogroup" aria-label="What are you building?">
            {OPTIONS.map(o => (
              <button
                key={o.key}
                type="button"
                role="radio"
                aria-checked={o.costOnly === !!costOnly}
                className={`vt-compact__pill ${o.costOnly === !!costOnly ? 'vt-compact__pill--active' : ''}`}
                title={o.desc}
                onClick={() => onChange(o.costOnly)}
              >
                <span aria-hidden="true">{o.icon}</span> {o.title}
              </button>
            ))}
          </div>
        </div>
        <p className="vt-compact__desc">{active.desc}</p>
      </div>
    );
  }

  return (
    <div className="vt-wrapper">
      <p className="vt-label">What are you building?</p>
      <div className="vt-options">
        {OPTIONS.map(o => (
          <label key={o.key} className={`vt-option ${o.costOnly === !!costOnly ? 'vt-option--active' : ''}`}>
            <input
              type="radio"
              name="buildType"
              value={o.key}
              checked={o.costOnly === !!costOnly}
              onChange={() => onChange(o.costOnly)}
            />
            <div className="vt-option__body">
              <div className="vt-option__header">
                <span className="vt-option__icon">{o.icon}</span>
                <span className="vt-option__title">{o.title}</span>
              </div>
              <p className="vt-option__desc">{o.desc}</p>
            </div>
          </label>
        ))}
      </div>
    </div>
  );
}

export default BuildTypeToggle;
